import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CsvDocumentInfo } from '../../models/chat.model';

/**
 * Componente popup para solicitar información y ejecutar consulta sobre CSV/Excel
 */
@Component({
    selector: 'app-query-csv-popup',
  templateUrl: './query-csv.component.html',
  styleUrls: ['./query-csv.component.scss'],
    standalone: false
})
export class QueryCsvComponent implements OnInit, OnChanges {
  /** Consulta original que disparó el popup */
  @Input() query!: string;
  /** Lista de archivos CSV disponibles para selección */
  @Input() csvDocuments: CsvDocumentInfo[] = [];
  /** Evento cuando el usuario cancela */
  @Output() cancel = new EventEmitter<void>();
  /** Evento cuando el usuario envía form con source y top_k */
  @Output() submit = new EventEmitter<{ original_filename: string }>();

  form!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      original_filename: ['', Validators.required]
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['csvDocuments'] && this.form) {
      const docs = this.csvDocuments || [];
      const current = this.form.get('original_filename')?.value;
      const exists = docs.some(d => d.original_filename === current);
      if (!exists) {
        // Mantener placeholder hasta que el usuario seleccione
        this.form.get('original_filename')?.setValue('');
      }
    }
  }

  /** Cancela la operación */
  onCancel(): void {
    this.cancel.emit();
  }

  /** Emite los datos del formulario */
  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }
    const { original_filename } = this.form.value;
    this.submit.emit({ original_filename });
  }
}
